import React from "react";
import ResetLocalStorageButton from "./ResetLocalStorageButton ";

const AppHeader = ({ pageNo }) => {
  let step = null;

  if (pageNo > 0 && pageNo < 7) step = 1;
  else if (pageNo > 6 && pageNo < 9) step = 2;
  else if (pageNo > 8) step = 3;
  else step = 0;

  return (
    <>
      <div className="driver-record-head" style={{ position: "relative" }}>
        Driver Record
        {/* Adjust the button to the right corner */}
        
          <div
            style={{
              position: "absolute",
              top: "50%",
              right: "10px",
              transform: "translateY(-50%)",
            }}
          >
            {/* Your button component goes here */}
           <ResetLocalStorageButton/>
          </div>
        
      </div>

      {pageNo < 11 ? (
        <div className="navigation">
          <ul className="nav-component text-center">
            <li className={step === 1 ? "active" : ""} id="step1">
              <a href="#">
                <span>1</span>Driver Information
              </a>
            </li>
            <li id="step2" className={step === 2 ? "active" : ""}>
              <a href="#">
                <span>2</span>Employment History
              </a>
            </li>
            <li id="step3" className={step === 3 ? "active" : ""}>
              <a href="#">
                <span>3</span>Other Information
              </a>
            </li>
          </ul>
        </div>
      ) : (
        <div style={{ height: "50px" }}></div>
      )}
    </>
  );
};

export default AppHeader;
